export enum ArticleStatus {
    Draft = 'draft',
    Published = 'published',
    Hidden = 'hidden',
}

/**
 * The bucket assignment type for a module assignment.
 * - General: article is accessible to all users who complete the module, regardless of bucket
 * - One / Two: article is only accessible to users in that specific bucket for the module
 */
export enum ArticleAssignmentBucket {
    General = 'general',
    One = 'one',
    Two = 'two',
}

/**
 * User's reaction to an article
 */
export enum ArticleReaction {
    None = 'none',
    Liked = 'liked',
    Disliked = 'disliked',
}
